import type React from 'react';
import { WelcomeStepView } from './WelcomeStepView';
import { useWelcomeStep } from './useWelcomeStep';

/** `/onboarding/start`: the greeting and the path choice. */
export const WelcomeStep: React.FC = () => (
    <WelcomeStepView {...useWelcomeStep()} />
);
